import { useEffect, useState } from "react";
import ReactTooltip from "react-tooltip";
import "./Dashboard.scss";
import DashboardRoutes from "./Routes";
import DashboardTabs from "./_root/components/DashboardTabs/DashboardTabs";
import Footer from "./_root/components/Footer/Footer";
import LastUpdated from "./_root/components/LastUpdated/LastUpdated";
import SubscriptionAlert from "./_root/components/SubscriptionAlert/SubscriptionAlert";
import TabMenu from "./_root/components/TabMenu/TabMenu";
import NewTabModal from "./_root/components/TabModal/NewTabModal";
import TabListModal from "./_root/components/TabModal/TabListModal";
import {
  UserPanelsProvider,
  useUserPanels,
} from "./_root/contexts/UserPanelsContext";
import Tooltip from "./_shared/components/Tooltip";
import { useQuery } from "@tanstack/react-query";
import { API } from "aws-amplify";

export type DashboardModal = "longbowTabs" | "customTabs" | "createTab";

function Dashboard() {
  const [openModal, setOpenModal] = useState<DashboardModal | null>(null);

  const closeModal = () => setOpenModal(null);

  const { panels } = useUserPanels();

  useQuery({
    queryKey: ["stayOnline"],
    queryFn: async () =>
      (await API.post("auth", "/cognito/usersOnline", {})),
    refetchInterval: 300000, //5 minutes
  });

  useEffect(() => {
    ReactTooltip.rebuild();
  }, []);

  return (
    <div id="dashboard-page">
      <div className="update-section">
        <SubscriptionAlert />
        <LastUpdated />
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          width: "100vw",
          padding: "0 40px",
          gap: 12,
        }}
      >
        <DashboardTabs setOpenModal={setOpenModal} />
        <TabMenu setOpenModal={setOpenModal} />
        <TabListModal
          open={openModal === "longbowTabs"}
          onClose={closeModal}
          title="Longbow Tabs"
          subtitle="Add a tab curated by Longbow to your dashboard."
          panels={panels.filter((panel) => panel.longbow_panel)}
        />
        <TabListModal
          open={openModal === "customTabs"}
          onClose={closeModal}
          title="My Tabs"
          subtitle="Add a custom tab to your dashboard."
          panels={panels.filter((panel) => !panel.longbow_panel)}
        />
        <NewTabModal open={openModal === "createTab"} onClose={closeModal} />
      </div>
      <DashboardRoutes />
      <Footer />
      <Tooltip />
    </div>
  );
}

const withUserPanels = () => (
  <UserPanelsProvider>
    <Dashboard />
  </UserPanelsProvider>
);

export default withUserPanels;
